// extracted by mini-css-extract-plugin
export var calendarView = "_nc-0";